<template>
  <div class="zx-list-box">
    <div class="list-content">
      <h1 class="title" v-html="title"></h1>
      <div class="list-content-text">
        <span class="text">{{ creatTime | creatTimeFormat }}</span>
        <span class="text">
          <van-icon name="eye-o" />
          <span style="margin-left: 4px" v-html="number"></span>
        </span>
        <span class="author" v-html="author"></span>
      </div>
    </div>
    <img v-show="img" class="list-img" :src="$global.imgUrl + img" alt="" />
  </div>
</template>

<script>
import { Icon } from "vant";
export default {
  components: {
    "van-icon": Icon,
  },
  filters: {
    creatTimeFormat(value) {
      if (value) {
        let nowDate = new Date();
        let nowYear = nowDate.getFullYear();
        let valueDate = new Date(value);
        let valueYear = valueDate.getFullYear();
        if (nowYear === valueYear) {
          return value.slice(5, 10);
        } else {
          return value.slice(0, 10);
        }
      } else {
        return "";
      }
    },
  },
  props: ["img", "creatTime", "number", "author", "title"],
  data() {
    return {
      searchStr: "",
    };
  },
  computed: {
    // highLightTitle() {
    //   return this.title.replaceAll(
    //     this.searchStr,
    //     `<span style="color:#517EF2">${this.searchStr}</span>`
    //   );
    // },

    // highLightAuthor() {
    //   return this.author
    //     ? this.author.replaceAll(
    //         this.searchStr,
    //         `<span style="color:#517EF2">${this.searchStr}</span>`
    //       )
    //     : "";
    // },
    /*
    highLightNumber() {
      return (this.number + "").replaceAll(
        this.searchStr,
        `<span style="color:#517EF2">${this.searchStr}</span>`
      );
    },
    */
  },
  created() {
    // this.searchStr = this.$route.query.paramStr;
  },
};
</script>

<style scoped lang="scss">
.zx-list-box {
  display: flex;
  margin-top: 15px;
  padding-bottom: 15px;
  min-height: 96px;
  .list-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-right: 14px;
    h1 {
      &::v-deep h1 {
        font-size: 16px !important;
      }
      font-size: 16px;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .list-content-text {
      font-size: 12px;
      color: #999999;
      .text {
        margin-right: 12px;
        vertical-align: middle;
      }
      .author {
        display: inline-block;
        width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
      }
    }
  }
  .list-img {
    width: 80px;
    height: 80px;
    border-radius: 6px;
  }
}
</style>
